import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type IncidentListItem = ResultOf<
  typeof incidentListQuery
>["incidents"]["data"][number];

export const incidentListQuery = graphql(`
  query IncidentList(
    $page: Int!
    $first: Int!
    $search: String
    $statuses: [IncidentStatus!]
    $supplier_id: ID
    $pro_driver_id: ID
    $work_order_id: ID
    $orderBy: [QueryIncidentsOrderByOrderByClause!]
  ) {
    incidents(
      page: $page
      first: $first
      search: $search
      statuses: $statuses
      supplier_id: $supplier_id
      pro_driver_id: $pro_driver_id
      work_order_id: $work_order_id
      orderBy: $orderBy
    ) {
      data {
        id
        reference
        status
        closed_outcome
        type
        found_at
        currency
        claim_opened_at
        excess_amount
        supplier {
          id
          name
        }
        proDriver {
          id
          name
        }
        workOrder {
          id
          reference
        }
      }
      paginatorInfo {
        ...PaginationFields
      }
    }
  }
`);
